




























import {
  Component,
  Emit,
  Model,
  Prop,
  Vue,
  Watch
} from "vue-property-decorator";

import directiveInfiniteScroll from "./directive-infinite-scroll.ts";
import { splitArray } from "./splitArray.ts";
@Component({
  components: {},
  directives: {
    // TODO:需要优化，table的高度固定项
    "el-table-infinite-scroll": directiveInfiniteScroll
  }
})
/**
  FIXME: 高度设置有问题
  TODO: 外部数据变化，比如，splice，改变内部data数据
 * 
 */
export default class CustomTableScroll extends Vue {
  @Prop({ type: [Array], default: () => ({}) }) data!: any;
  // 建议设置table组件的样式，max-height="400px" 和默认值差个20，400是pageSize为10,
  // 注意配置pageSize的大小 pageSize * 30 = tableMaxHeight
  // 本组件的maxHeight和tableMaxHeight 相差大概50px
  @Prop({ type: [String, Number], default: "" }) height: [String, Number];
  @Prop({ type: [String, Number], default: "420px" }) maxHeight: [
    String,
    Number
  ];
  @Prop({ type: Number, default: 10 }) pageSize: Number; // 抛出参数；每页多少
  @Prop({ type: Number, default: 200 }) sleep: Number; // loading太快，需要sleep一定时间，单位：ms

  private childDatalist = [];
  private rootDatalist = [];
  private isLoading = false; // 状态抛出
  private isFinished = false; // 完成状态
  private pageNum = 0; // 当前到多少页了

  @Watch("pageNum") onLoad(val) {
    this.$emit("load", val);
  }
  @Watch("isFinished") onFinished(val) {
    this.$emit("finish", val);
  }
  @Watch("data") onDataChange() {
    this.init();
  }
  mounted() {
    this.init();
  }
  toggleInit() {
    this.init();
  }
  init() {
    const { data, commitItems, handleAllDatalist } = this;
    handleAllDatalist(data);
    // 首次进来，提前加载有部分
    commitItems();
  }

  get splitDataList() {
    const { rootDatalist, pageSize: splitCount } = this;
    return splitArray(rootDatalist, splitCount);
  }

  handleTableLoadMore(val) {
    if (val) return;
    this.commitItems();
  }
  handleAllDatalist(rowDatalist) {
    const { commitAllItems } = this;
    commitAllItems({ dataList: rowDatalist });
  }

  async commitItems() {
    requestAnimationFrame(async _ => {
      const { splitDataList, addItems } = this;
      this.isLoading = true;
      splitDataList.forEach((chunk, index) => {
        if (index === this.pageNum) {
          addItems(chunk);
        }
      });
      const changeSetStatus = async () => {
        if (splitDataList.length !== this.pageNum) {
          this.pageNum++;
          this.isLoading = false;
        } else {
          this.isFinished = true;
          this.isLoading = false;
        }
      };
      changeSetStatus();
    });
  }
  async commitAllItems({ dataList }) {
    this.clearItems();
    this.addAllItems(dataList);
  }
  clearItems() {
    this.childDatalist = [];
    this.rootDatalist = [];
    this.pageNum = 0;
  }
  addItems(items) {
    this.childDatalist.push(...items);
  }
  addAllItems(items) {
    if (items.length > this.rootDatalist.length) {
      this.rootDatalist = items;
    }
  }
  fInt(height) {
    return isNaN(parseInt(height)) ? height : parseInt(height) + "px";
  }
}
